import { TaskRatingStarsController } from './task-rating-stars.controller'

function taskRatingStarsDirective () {
  return {
    restrict: 'E',
    scope: {
      readOnly: '<',
      starsCount: '<',
      selectedStars: '<'
    },
    templateUrl: '/workflow/directives/task-rating-stars/task-rating-stars-directive.html?$$REVISION$$',
    controller: TaskRatingStarsController
  }
}

export { taskRatingStarsDirective }
